/**
 * Post-take "reset gain" reminder — Pro Tools-style yellow warning ribbon.
 *
 * Fires only when the previous and next cue categories differ by enough
 * dB that the actor should re-check their gain knob. Yellow warning bar
 * with black border + black text — classic PT alert chrome.
 */
export interface ResetReminderProps {
  text: { zh: string; en: string } | null
  locale?: 'zh' | 'en'
  onDismiss: () => void
}

export function ResetReminder({ text, locale = 'en', onDismiss }: ResetReminderProps) {
  if (!text) return null
  return (
    <div
      role="status"
      aria-live="polite"
      className="pt-ribbon flex items-center gap-3 px-3 py-2 pr-2 text-[13px]"
    >
      <span
        aria-hidden="true"
        className="flex h-6 w-6 shrink-0 items-center justify-center rounded-sm border border-pt-text bg-pt-warn text-base"
      >
        🎚️
      </span>
      <div className="flex-1 leading-snug text-pt-text">{locale === 'zh' ? text.zh : text.en}</div>
      <button
        type="button"
        onClick={onDismiss}
        className="pt-btn flex h-6 w-6 items-center justify-center text-[14px] leading-none"
        aria-label="Dismiss reset reminder"
      >
        ×
      </button>
    </div>
  )
}
